import React from 'react';
import { Title, Body, Theme } from '@routific/hive';

interface Props {
  name: string | null | undefined;
  variant: 'title' | 'body';
  ellipsis?: boolean;
}

const RouteNameText: React.FC<Props> = ({
  name,
  variant,
  ellipsis = true,
}) => {
  if (!name) {
    return null;
  }

  const ellipsisProp = ellipsis ? { tooltip: name } : false;

  if (variant === 'title') {
    return (
      <Title level={5} ellipsis={ellipsisProp} style={{ marginRight: Theme.Spacing.mdSpacing }}>
        {name}
      </Title>
    );
  }

  return (
    <Body ellipsis={ellipsisProp} style={{ marginRight: Theme.Spacing.mdSpacing }}>
      {name}
    </Body>
  );
};

export default RouteNameText;

